import { SelectItem } from "@/shared/components/ui/select";
import {
  classColorStyle,
  WOW_CLASS_LABELS,
  WOW_CLASSES,
} from "@/shared/lib/wowClass";

// Option rows for a WoW-class <Select>, shared by roster and setup. The span
// carries the class color so the check indicator keeps the theme color.
export function WowClassSelectItems() {
  return (
    <>
      {WOW_CLASSES.map((c) => (
        <SelectItem key={c} value={c}>
          <span style={classColorStyle(c)}>{WOW_CLASS_LABELS[c]}</span>
        </SelectItem>
      ))}
    </>
  );
}
